export class Network {
    mac: string;
    ip: string;
    mascara: string;
    inet: string;
    
    constructor(){}
}

export class Iptables {
    ip: string;
    allow: boolean;
    descr: string;
    
    constructor(){}
}

export interface IRuta {
    ruta: string
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/network.ts